import { render, staticRenderFns } from "./ECTimeStudy.vue?vue&type=template&id=4b01843a&scoped=true&"
import script from "./ECTimeStudy.vue?vue&type=script&lang=js&"
export * from "./ECTimeStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b01843a",
  null
  
)

export default component.exports